import { useContext } from "react";
import { BannerContext } from "./BannerContext";

const useBanner = () => {
  const { openBanners, handleAddBannerToOpenBanners, handleRemoveBannerFromOpenBanners } = useContext(BannerContext);

  return { openBanners, handleAddBannerToOpenBanners, handleRemoveBannerFromOpenBanners };
};

export { useBanner };
